
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_wih1l_139hk_13",
  "tools": "awsui_tools_wih1l_139hk_24",
  "tools-filtering": "awsui_tools-filtering_wih1l_139hk_33",
  "tools-align-right": "awsui_tools-align-right_wih1l_139hk_46",
  "tools-clear-sort": "awsui_tools-clear-sort_wih1l_139hk_50",
  "tools-pagination": "awsui_tools-pagination_wih1l_139hk_53",
  "tools-preferences": "awsui_tools-preferences_wih1l_139hk_53",
  "tools-small": "awsui_tools-small_wih1l_139hk_59",
  "table": "awsui_table_wih1l_139hk_63",
  "table-layout-fixed": "awsui_table-layout-fixed_wih1l_139hk_70",
  "wrapper": "awsui_wrapper_wih1l_139hk_74",
  "variant-stacked": "awsui_variant-stacked_wih1l_139hk_81",
  "wrapper-content-measure": "awsui_wrapper-content-measure_wih1l_139hk_81",
  "variant-container": "awsui_variant-container_wih1l_139hk_81",
  "has-footer": "awsui_has-footer_wih1l_139hk_84",
  "has-header": "awsui_has-header_wih1l_139hk_87",
  "cell-merged": "awsui_cell-merged_wih1l_139hk_104",
  "cell-merged-content": "awsui_cell-merged-content_wih1l_139hk_116",
  "empty": "awsui_empty_wih1l_139hk_132",
  "loading": "awsui_loading_wih1l_139hk_136",
  "selection-control": "awsui_selection-control_wih1l_139hk_145",
  "selection-control-header": "awsui_selection-control-header_wih1l_139hk_152",
  "selection-control-content-spans-rows": "awsui_selection-control-content-spans-rows_wih1l_139hk_157",
  "header-secondary": "awsui_header-secondary_wih1l_139hk_164",
  "variant-full-page": "awsui_variant-full-page_wih1l_139hk_178",
  "table-has-header": "awsui_table-has-header_wih1l_139hk_184",
  "header-controls": "awsui_header-controls_wih1l_139hk_192",
  "variant-embedded": "awsui_variant-embedded_wih1l_139hk_204",
  "variant-borderless": "awsui_variant-borderless_wih1l_139hk_204",
  "footer-wrapper": "awsui_footer-wrapper_wih1l_139hk_209",
  "footer": "awsui_footer_wih1l_139hk_209",
  "footer-with-pagination": "awsui_footer-with-pagination_wih1l_139hk_217",
  "footer-pagination": "awsui_footer-pagination_wih1l_139hk_225",
  "thead-active": "awsui_thead-active_wih1l_139hk_229",
  "row": "awsui_row_wih1l_139hk_230",
  "row-selected": "awsui_row-selected_wih1l_139hk_231",
  "skeleton-loading-cell": "awsui_skeleton-loading-cell_wih1l_139hk_235"
};
  